import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { useEditCtaContext } from "../../../../../../context/EditCtaContext";

const SocialGroup = () => {
  const { formData, setFormData } = useEditCtaContext();
  const [showPickers, setShowPickers] = useState({});

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleColorChange = (field, color) => {
    setFormData({ ...formData, [field]: color.hex });
  };

  const togglePicker = (id) => {
    setShowPickers((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="flex flex-col px-6 pb-6">
      {/* Step Header */}
      <div className="flex flex-col pt-4 mb-12">
        <h2 className="text-white text-2xl font-semibold leading-[30px] tracking-[-0.15px] mb-0">
          Buttons
        </h2>
        <p className="text-white text-xl font-medium leading-6">
          Configure your action buttons
        </p>
      </div>

      {/* Form Fields: five buttons */}
      <div className="flex flex-col gap-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="flex flex-col gap-2 pb-2 border-b border-transparent last:border-b-0"
          >
            <div className="flex items-center justify-between">
              <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
                Button {i}
              </label>
            </div>

            {/* Label input */}
            <div className="flex flex-col gap-1">
              <label className="text-white text-sm font-medium">Label</label>
              <input
                type="text"
                placeholder={`Button ${i} label`}
                value={formData?.[`button${i}Label`] ?? ``}
                onChange={(e) =>
                  handleChange(`button${i}Label`, e.target.value)
                }
                className="h-9 px-3 py-2 rounded border border-[#DCDFE3] bg-white text-base text-gray-700 placeholder:text-[#758195] focus:outline-none focus:ring-1 focus:ring-purple-500"
              />
            </div>

            {/* Link input */}
            <div className="flex flex-col gap-1">
              <label className="text-white text-sm font-medium">Link</label>
              <input
                type="text"
                placeholder={`https://example.com`}
                value={formData?.[`button${i}Link`] ?? ``}
                onChange={(e) => handleChange(`button${i}Link`, e.target.value)}
                className="h-9 px-3 py-2 rounded border border-[#DCDFE3] bg-white text-base text-gray-700 placeholder:text-[#758195] focus:outline-none focus:ring-1 focus:ring-purple-500"
              />
            </div>
            {/* Font Color and Button Color */}
            <div className="flex items-start gap-[54px]">
              <div className="flex flex-col gap-1">
                <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
                  Font Color
                </label>
                <div className="relative">
                  <div
                    onClick={() => togglePicker(`fontColor${i}`)}
                    className="w-11 h-11 rounded border border-white cursor-pointer"
                    style={{
                      backgroundColor:
                        formData?.[`button${i}FontColor`] || "#D8D8D8",
                    }}
                  />
                  {showPickers[`fontColor${i}`] && (
                    <div className="absolute z-10 mt-2">
                      <div
                        className="fixed inset-0"
                        onClick={() => togglePicker(`fontColor${i}`)}
                      />
                      <SketchPicker
                        color={formData?.[`button${i}FontColor`] || "#D8D8D8"}
                        onChange={(color) =>
                          handleColorChange(`button${i}FontColor`, color)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
                  Button Color
                </label>
                <div className="relative">
                  <div
                    onClick={() => togglePicker(`buttonColor${i}`)}
                    className="w-11 h-11 rounded border border-white cursor-pointer"
                    style={{
                      backgroundColor:
                        formData?.[`button${i}BackgroundColor`] || "#0BA007",
                    }}
                  />
                  {showPickers[`buttonColor${i}`] && (
                    <div className="absolute z-10 mt-2">
                      <div
                        className="fixed inset-0"
                        onClick={() => togglePicker(`buttonColor${i}`)}
                      />
                      <SketchPicker
                        color={
                          formData?.[`button${i}BackgroundColor`] || "#0BA007"
                        }
                        onChange={(color) =>
                          handleColorChange(`button${i}BackgroundColor`, color)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialGroup;

